"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getItemsByType = exports.getFormattedMenuItems = exports.getSlug = void 0;

var _tslib = require("tslib");

var _slugify = _interopRequireDefault(require("slugify"));

var _map2 = _interopRequireDefault(require("lodash/map"));

var _filter2 = _interopRequireDefault(require("lodash/filter"));

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _flatMap2 = _interopRequireDefault(require("lodash/flatMap"));

var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));

var _types = require("../types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getSlug = function getSlug(typeDescription) {
  return (0, _slugify["default"])(typeDescription, {
    lower: true,
    strict: true
  });
};

exports.getSlug = getSlug;

var getFormattedMenuItems = function getFormattedMenuItems(menuTypes) {
  return (0, _isArray2["default"])(menuTypes) && menuTypes.length ? (0, _flatMap2["default"])(menuTypes, function (menuType) {
    var menuTypeItems = menuType.itemType === _types.CustomPizza.CustomPizzaCode ? (0, _sortBy2["default"])(menuType.menuItems, ['menuItemCode']) : menuType.menuItems;
    return (0, _map2["default"])(menuTypeItems, function (menuItem) {
      return (0, _tslib.__assign)((0, _tslib.__assign)({}, menuItem), {
        typeDescription: menuType.typeDescription
      });
    });
  }) : [];
};

exports.getFormattedMenuItems = getFormattedMenuItems;

var getItemsByType = function getItemsByType(menu, slug) {
  var _a;

  var filteredTypes = (0, _filter2["default"])(menu === null || menu === void 0 ? void 0 : menu.menuTypes, function (menuType) {
    return (menuType === null || menuType === void 0 ? void 0 : menuType.itemType) === _types.CustomPizza.CustomPizzaCode || slug === getSlug(menuType === null || menuType === void 0 ? void 0 : menuType.typeDescription);
  });
  return (0, _isArray2["default"])(filteredTypes) && (filteredTypes === null || filteredTypes === void 0 ? void 0 : filteredTypes.length) === 1 && ((_a = filteredTypes === null || filteredTypes === void 0 ? void 0 : filteredTypes[0]) === null || _a === void 0 ? void 0 : _a.itemType) === _types.CustomPizza.CustomPizzaCode ? [] : getFormattedMenuItems(filteredTypes);
};

exports.getItemsByType = getItemsByType;